import { render, staticRenderFns } from "./MediaBrixIcon.vue?vue&type=template&id=3b541ddf&"
import script from "./MediaBrixIcon.vue?vue&type=script&lang=js&"
export * from "./MediaBrixIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports